import accessRecordView from './src/accessRecord/accessRecordView.vue'

let views = {
    accessRecordView
};

export default views;
